import parse from 'utils/parse';
import type { MessageDescriptor } from 'react-intl';

import messages from './questions-banner.i18n';

const makeTestId = (...ids: string[]): string => parse.toTestId('landing', 'questions-banner', ...ids);

const testId = Object.freeze({
  component: makeTestId(),
});

const translation = messages.pages.landing.questionsBanner.livejasmin;

interface Row {
  id: string;
  question: MessageDescriptor;
  answer: MessageDescriptor;
  hasList?: boolean;
}

const rows: Array<Row> = [
  {
    id: '1',
    question: translation.first.question,
    answer: translation.first.answer,
  },
  {
    id: '2',
    question: translation.second.question,
    answer: translation.second.answer,
  },
  {
    id: '3',
    question: translation.third.question,
    answer: translation.third.answer,
  },
  {
    id: '4',
    question: translation.fourth.question,
    answer: translation.fourth.answer,
  },
  {
    id: '5',
    question: translation.fifth.question,
    answer: translation.fifth.answer,
    hasList: true,
  },
];

const PAYOUT_THRESHOLD = 100;

export type { Row };
export { testId, rows, PAYOUT_THRESHOLD };
